import React from 'react';
import { Switch } from 'react-router-dom';

import ErrorBoundaryRoute from 'app/shared/error/error-boundary-route';

import AidasObject from './aidas-object';
import AidasObjectDetail from './aidas-object-detail';
import AidasObjectUpdate from './aidas-object-update';
import AidasObjectDeleteDialog from './aidas-object-delete-dialog';

const Routes = ({ match }) => (
  <>
    <Switch>
      <ErrorBoundaryRoute exact path={`${match.url}/new`} component={AidasObjectUpdate} />
      <ErrorBoundaryRoute exact path={`${match.url}/:id/edit`} component={AidasObjectUpdate} />
      <ErrorBoundaryRoute exact path={`${match.url}/:id`} component={AidasObjectDetail} />
      <ErrorBoundaryRoute path={match.url} component={AidasObject} />
    </Switch>
    <ErrorBoundaryRoute exact path={`${match.url}/:id/delete`} component={AidasObjectDeleteDialog} />
  </>
);

export default Routes;
